// @flow
import Toaster from "./Toast";

const toaster = new Toaster();

export { default as Position } from "./Positions";

export default toaster;



// WEBPACK FOOTER //
// ./src/index.js